import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'checkEmpty'
})
export class CheckEmptyPipePipe implements PipeTransform {

    transform(value: any): any {
        if (value === undefined || value === null) {
            return '---';
        }

        if (typeof value === 'string' && value?.length === 0) {
            return '---';
        }

        return value;
    }

}
